import React from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import { vc_base, vc_color } from '../../assets/js/Brand'

// components
import Heading from '../atoms/BaseHeading'
import Txt from '../atoms/BaseTxt'
import Breadcrumb from '../molecules/Breadcrumb'
import Pagination from '../molecules/Pagination'
import ListItem from '../molecules/ListItem'
import Layout from '../templates/Default'

// template
const RoleTwo = (props) => {
  // 現在の権限の情報取得
  const thisRole = props.data.currentRole
  // 現在のページの記事情報取得
  const posts = props.data.currentPost.edges
  // 現在の権限の大カテゴリーの情報取得
  const parentCat = props.data.currentCatOne
  // 現在の権限の中カテゴリーの記事数取得
  const totalCount = props.data.currentAllPost.totalCount
  // ページネーション用
  const { catRole, catOne, currentPage, numPages } = props.pageContext
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages
  const hasPages = numPages <= 2 ? true : false
  const prevPage =
    currentPage - 1 === 1
      ? `/roles/${catRole}/${catOne}/`
      : `/roles/${catRole}/${catOne}/${currentPage - 1}`.toString()
  const nextPage = `/roles/${catRole}/${catOne}/${currentPage + 1}`.toString()

  return (
    <Layout catOne={parentCat.frontmatter.cat}>
      <Helmet>
        <html lang="ja" />
        <meta charSet="utf-8" />
        <meta http-equiv="Pragma" content="no-cache" />
        <meta http-equiv="Cache-Control" content="no-cache" />
        <meta http-equiv="Expires" content="0" />
        <title>
          {`「${thisRole.frontmatter.title}」が対象となる「${
            parentCat.frontmatter.title
          }」一覧${!isFirst ? ` ${currentPage}ページ目` : ''}`}
          ｜{thisRole.frontmatter.title}｜ヘルプ
        </title>
      </Helmet>

      <Breadcrumb
        breadcrumb={[
          {
            id: 1,
            name: `「${thisRole.frontmatter.title}」が対象となるカテゴリー`,
            link: `/roles${thisRole.fields.slug}`,
          },
        ]}
      />

      <Heading level={1} className="title-page">
        「{thisRole.frontmatter.title}」が対象となる「
        {parentCat.frontmatter.title}」一覧
        <TotalCount>（全{totalCount}件）</TotalCount>
      </Heading>

      <PageList>
        <ul>
          {posts.map(({ node }) => {
            return (
              <ListItem key={node.id} link={node.fields.slug}>
                <Txt type={'span'} className="anchor-text">
                  {node.frontmatter.title}
                </Txt>
              </ListItem>
            )
          })}
        </ul>
      </PageList>

      <Pagination
        link={`/roles/${catRole}/${catOne}/`}
        currentPage={currentPage}
        numPages={numPages}
        isFirst={isFirst}
        isLast={isLast}
        hasPages={hasPages}
        prevPage={prevPage}
        nextPage={nextPage}
      />
    </Layout>
  )
}

export default RoleTwo

// style
const TotalCount = styled.span`
  font-size: 65%;
  font-weight: normal;
`
const PageList = styled.div`
  border: 1px solid ${vc_color.border};
  border-radius: ${vc_base.pixel`0.5`};
  margin-top: ${vc_base.pixel};
`
